import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import TemplatesEmailInfoComponent from "./email-marketing-template.component";
import { prepares } from "../../../../../../../redux/prepares/action";
import { useSelector } from "react-redux";
import { selectPreparesQueryItems } from "../../../../../../../redux/prepares/selector";

export const EmailMarketingTemplatesComponent = ({

}: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [emailPlan, setEmailPlan] = useState<any>();
  const [selectedPlanId, setSelectedPlanId] = useState<any>(null);
  const queryEmailTemplatesData = useSelector(selectPreparesQueryItems)
  const parmas: any = useParams()
  const [isQuery, setIsQuery] = useState<boolean>(false)

  const handlePlanIdChange = (planId: any) => {
    setSelectedPlanId(planId);
  };

  const handleInnerFormChange: any = (event: any, field: string) => {
    setEmailPlan({ ...emailPlan, [field]: event });
  };

  const handlePlanSelect = (data: any) => {
    setEmailPlan(data);
  };

  const close = () => {
    navigate('/agencies/promotions/marketing/templates');
  };

  const back = () => {
    navigate('/agencies/promotions/marketing/templates')
  }

  const handleSubmit = async (event: any) => {

    const payload =
    {
      Id: emailPlan?.Id || 0,
      Name: emailPlan?.Name || '',
      Subject: emailPlan?.Subject || 0,
      BodyContent: emailPlan?.BodyContent || '',
      Attachmenturls: [],
      DesignFileurls: [],
      TemplateStatusId: 30,
      TemplateTypeId: 30,
      WebTemplateTypeId: 0,
      MappedEntities: [
        {
          Id: 0,
          OwnerTypeId: 69,
          OwnerId: selectedPlanId?.Id,
          OwnerTypeName: 'EmailPlan',
          OwnerName: selectedPlanId?.Name,
          Name: "",
          Description: "string",
          IsFunction: true,
          IsDomain: false,
          MarketingTemplateId: 0,
          IsApproved: true,
          DisplayOrder: 0
        }
      ],
    }

    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(prepares.resetAction({ actionType: 'update' }))
      await dispatch(prepares.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates`, entity: 'prepares', jsonData: {

          Records: [payload]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(prepares.resetAction({ actionType: 'create' }))
      await dispatch(prepares.create({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates`, entity: 'prepares', jsonData: {

          Records: [payload]

        }
      })).then(() => {
        back()
      })
    }
  }


  const queryEmailTemplates = async () => {
    await dispatch(prepares.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/query`,
      entity: 'prepares',
      jsonData: {
        "Records": [
          {
            "Id": parmas.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(() => {
    if (parmas.id > 0) {
      queryEmailTemplates()
    }
  }, [parmas.id]);

  useEffect(
    () => {

      if (isQuery) {
        setEmailPlan(queryEmailTemplatesData?.result?.items)
      }
    },
    [isQuery]
  )

  return (
    <div className="flex w-full justify-center items-center">
      <div className="w-full p-2 bg-white shadow-md rounded-md">
        <h1 className="text-xl font-bold mb-4 text-center">
          {emailPlan?.Id ? "Edit Templates" : "Create Email Template"}
        </h1>

        <div className="flex flex-col gap-4">
          <TemplatesEmailInfoComponent
            choosenEmailTemplate={emailPlan}
            choosenEmailPlan={emailPlan}
            emailBudget={{}}
            emailNotes={{}}
            handlePlanSelect={handlePlanSelect}
            handleInnerFormChange={handleInnerFormChange}
            onPlanIdChange={handlePlanIdChange}
            selectedPlanId={selectedPlanId}
            setSelectedPlanId={setSelectedPlanId}
          />
        </div>

        <div className="text-end">
          <button
            onClick={close}
            type="button"
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
          >
            Back
          </button>

          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            onClick={handleSubmit}
            type="submit"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
